<div class="wrapper">
  <div class="main-panel  primary-bg-color">
    <div class="content">
      <div class="container">
        <div class="row">
          <div class="title-header col-md-6 header-container mb-4 ">
            Change Password
          </div>
        </div>
        @if (!isLoading) {
          <div class="body-container mb-4"
            >
            <form [formGroup]="form">
              <div class="row">
                <div class="col-3">
                                <label [ngClass]="{'label-error': form.controls['currentPassword'].invalid &&
                                                      form.controls['currentPassword'].touched }">
                    Previous Password:
                    <div class="custom-input-container"
                                         [ngClass]="{'custom-input-container-error' :  form.controls['currentPassword'].invalid &&
                                                                          form.controls['currentPassword'].touched}">
                      <input
                        class="custom-input"
                        formControlName="currentPassword"
                        [type]="showPassword? 'text':'password' "
                                                [ngClass]="{'input-error': form.controls['currentPassword'].invalid &&
                                                              form.controls['currentPassword'].touched }"
                        maxlength="20">
                        <div class="view-password-button"
                          (mousedown)="showPassword = true;"
                          (mouseup) ="showPassword = false;"
                        (mouseleave)="showPassword = false;"></div>
                      </div>
                    </label>
                                <label [ngClass]="{'label-error': form.controls['newPassword'].touched &&
                                                                  (form.controls['newPassword'].invalid ||
                                                                  hasRepetition(this.form.controls['newPassword'].value))}">
                      New Password:
                      <div class="custom-input-container"
                                         [ngClass]="{'custom-input-container-error': form.controls['newPassword'].touched &&
                                                                         (form.controls['newPassword'].invalid ||
                                                                          hasRepetition(this.form.controls['newPassword'].value))}">
                        <input [type]="showNewPassword? 'text':'password' "
                          maxlength="20"
                          class="custom-input"
                                               [ngClass]="{'input-error': form.controls['newPassword'].touched &&
                                                              (form.controls['newPassword'].invalid  ||
                                                               hasRepetition(this.form.controls['newPassword'].value))}"
                          formControlName="newPassword">
                          <div class="view-password-button"
                            (mousedown)="showNewPassword = true;"
                            (mouseup) ="showNewPassword = false;"
                          (mouseleave)="showNewPassword = false;"></div>
                        </div>
                      </label>
                                <label [ngClass]="{'label-error': form.controls['confirmPassword'].touched &&
                                                      !passwordMatch}">
                        Confirm Password:
                        <div class="custom-input-container"
                                         [ngClass]="{'custom-input-container-error': form.controls['confirmPassword'].touched &&
                                                                         !passwordMatch}">
                          <input type="password"
                            [type]="showConfirmPassword? 'text':'password' "
                            maxlength="20"
                            class="custom-input"
                                               [ngClass]="{'input-error': form.controls['confirmPassword'].touched &&
                                                              !passwordMatch}"
                            formControlName="confirmPassword">
                            <div class="view-password-button"
                              (mousedown)="showConfirmPassword = true;"
                              (mouseup) ="showConfirmPassword = false;"
                            (mouseleave)="showConfirmPassword = false;"></div>
                          </div>
                          @if (form.controls['confirmPassword'].touched && !passwordMatch) {
                            <div class="not-match">
                              Passwords doest not match
                            </div>
                          }
                        </label>
                      </div>
                    </div>
                    <br>
                      <div class="row">
                        <div class="col-6">
                          <div class="password-rules">
                            <ul class="rule-fail">
                              <li [ngClass]="{'rule-pass':this.form.controls['newPassword'].value.length >= 9}">
                                Must have at least 9 characters
                              </li>
                              <li [ngClass]="{'rule-pass':hasRepetition(this.form.controls['newPassword'].value)}">
                                No repetition of characters
                              </li>
                              <li [ngClass]="{'rule-pass': pattern_UpperCase.test(this.form.controls['newPassword'].value)}">
                                Must have uppercase alphabet characters (A,B,C ...)
                              </li>
                              <li [ngClass]="{'rule-pass': pattern_LowerCase.test(this.form.controls['newPassword'].value)}">
                                Must have lowercase alphabet characters (a,b,c ...)
                              </li>
                              <li [ngClass]="{'rule-pass': pattern_Special.test(this.form.controls['newPassword'].value)}">
                                Must have at least one special character (!&#64;#$%^&*()\-_+=)
                              </li>
                              <li [ngClass]="{'rule-pass': pattern_Number.test(this.form.controls['newPassword'].value)}">
                                Must have at least one numerical character (0,1,2 ...)
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      <br>
                        <button class="button button-active"
                          (click)="showConfirmModal = true;"
                        [disabled]="!isFormValid">Save</button>
                      </form>
                    </div>
                  }
                  @if (isLoading) {
                    <div class="body-container mb-4">
                      <app-loading-component></app-loading-component>
                    </div>
                  }

                </div>
              </div>
            </div>
            <customer-confirm-modal
              [visible]="showConfirmModal"
              [title]="'Edit Password'"
              [message]="'Are you sure you want to save changes?'"
              (onConfirm)="onSave()"
              (onDismiss)="showConfirmModal = false;">
            </customer-confirm-modal>
            <info-modal
              [visible]="showSuccessModal"
              [title]="'Password Change Success'"
              (onConfirm)="logout()">
            </info-modal>
            <info-modal
              [visible]="showFailModal"
              [title]="modalTitle"
              [message]="modalMessage"
              (onConfirm)="showFailModal = false;">
            </info-modal>
          </div>
